import Udesk from 'Udesk';
import UdeskLocales from 'UdeskLocales';
import React from 'react';
import { Redirect } from 'react-router-dom';
import LayoutMenu from 'Component/common/layout-menu';
import { getCurrentRouteName, isConversationAnalysis } from 'Udesk/system/subApp';

class intelligentAnalysis extends React.Component {
    isRedirect(currentPath, toPath) {
        if (currentPath === toPath) {
            return true;
        }
        return false;
    }

    render() {
        let { route, location, sdkOptions } = this.props;

        let { locales } = this;

        const isVOC = isConversationAnalysis();

        const navLists = [
            {
                text: /* 规则模版 */ UdeskLocales['current'].pages.intelligentAnalysis.ruleTemplate
                    .index.ruleTemplate,
                pathName: getCurrentRouteName('ruleTemplate'),
                isActive: (match, location) => {
                    return location.pathname.includes('/rule-template');
                },
                isHidden:
                    !(
                        Udesk.data.init.user &&
                        Udesk.data.init.user.hasFeature('smart:point:template:root')
                    ) || isVOC,
            },
            {
                text: locales.components.pages.intelligentCollection.title,
                pathName: getCurrentRouteName('intelligentCollectionEntry'),
                isActive: (match, location) => {
                    return location.pathname.includes('/intelligent-collection');
                },
                isHidden:
                    !(
                        Udesk.data.init.user &&
                        Udesk.data.init.user.hasFeature('smart:information:root')
                    ) || isVOC,
            },
            {
                text: locales.components.pages.intelligentTags.title,
                pathName: getCurrentRouteName('intelligentTags'),
                isActive: (match, location) => {
                    return location.pathname.includes('/intelligent-tags');
                },
                isHidden: !(
                    Udesk.data.init.user && Udesk.data.init.user.hasFeature('smart:tag:root')
                ),
            },
            {
                text: locales.components.pages.sentimentAnalysis.title,
                pathName: getCurrentRouteName('sentimentAnalysis'),
                isActive: (match, location) => {
                    return location.pathname.includes('/public-sentiment');
                },
                isHidden:
                    !(
                        Udesk.data.init.user &&
                        Udesk.data.init.user.hasFeature('smart:discovery:root')
                    ) || isVOC,
            },
            {
                text: locales.components.pages.dataPreprocess.title,
                pathName: getCurrentRouteName('dataPreprocess'),
                isActive: (match, location) => {
                    return location.pathname.includes('/data-preprocess');
                },
                isHidden:
                    !(
                        Udesk.data.init.user && Udesk.data.init.user.hasFeature('datapre:rule:root')
                    ) || isVOC,
            },

            {
                text: locales.components.pages.connectedByConversation.title,
                pathName: getCurrentRouteName('connectedByConversationIndex'),
                isActive: (match, location) => {
                    return location.pathname.includes('/connected-by-conversation');
                },
                isHidden:
                    !(Udesk.data.init.user && Udesk.data.init.user.hasFeature('smart:call:root')) ||
                    isVOC,
            },
            {
                text: locales.components.pages.businessAnalysis.title,
                pathName: getCurrentRouteName('businessAnalysisList'),
                isActive: (match, location) => {
                    return location.pathname.includes('/business-analysis');
                },
                isHidden:
                    !(
                        Udesk.data.init.user &&
                        Udesk.data.init.user.hasFeature('smart:analysis:root')
                    ) || isVOC,
            },
            {
                text: /* 分析报表 */ locales.pages.intelligentAnalysis.analysisReportTitle,
                pathName: getCurrentRouteName('analysisReport'),
                isActive: (match, location) => {
                    return location.pathname.includes('/analysis-report');
                },
                isHidden:
                    !(
                        Udesk.data.init.user &&
                        Udesk.data.init.user.hasFeature('smart:analysis:report:root')
                    ) || isVOC,
            },
        ].filter((nav) => !nav.isHidden);

        if (
            this.isRedirect(route.path, location.pathname) &&
            sdkOptions.props.landingPath != null
        ) {
            let toPath = location.pathname + sdkOptions.props.landingPath;
            return <Redirect to={toPath} sdkOptions={sdkOptions} />;
        } else if (navLists.length > 0 && this.isRedirect(route.path, location.pathname)) {
            let toPath = Udesk.ui.routing.getRouteFirstBottomedChildRoutePath({
                routeName: navLists[0].pathName,
            });
            return <Redirect to={toPath} sdkOptions={sdkOptions} />;
        } else {
            return (
                <div className="semantic-intelligence">
                    <LayoutMenu
                        {...this.props}
                        navLists={navLists}
                        menuTitle={locales.components.pages.menuTitleList.intelligentAnalysisTitle}
                    />
                </div>
            );
        }
    }
}

export default Udesk.react.udeskify(intelligentAnalysis);
